export default __webpack_public_path__ + "static/media/kclogo-bw.f482083f.png";